import { render, staticRenderFns } from "./BiocharQueryModal.vue?vue&type=template&id=2f931b5a&scoped=true&"
import script from "./BiocharQueryModal.vue?vue&type=script&lang=js&"
export * from "./BiocharQueryModal.vue?vue&type=script&lang=js&"
import style0 from "./BiocharQueryModal.vue?vue&type=style&index=0&id=2f931b5a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f931b5a",
  null
  
)

export default component.exports